/*
  Life InStyle — the calm "most we can sell" line (Naman, 2026-10-08, "AGREED";
  rewritten 2026-10-21 when Naman ruled the website must NEVER show how many of
  an item the store has).

  Shopify already refuses to sell past stock (every tracked variant is "deny").
  This file only changes what the shopper is TOLD, and it never knows a stock
  number:
    - No stock number up front, none in the page source.
    - When Add to cart is refused (HTTP 422), one calm line goes under the
      button: "That's the most we can sell online right now. Please call us at
      604-498-6766 for more." (theme string cart_quantity_error_html, editable
      under Edit default theme content; assets/product-form.js already swapped
      Shopify's own refusal text for it).
  The only thing the page learns about stock is a yes/no flag per tracked
  variant, written by sections/instyle-product.liquid (data-instyle-stock):
  true = can be bought right now, false = cannot.
  Cart page and drawer: the quantity box has no stock limit any more
  (snippets/instyle-cart-max.liquid); Shopify caps the quantity and
  assets/cart.js shows the same sentence under the item.
*/
(function () {
  if (window.instyleStockReady) return;
  window.instyleStockReady = true;

  /* ---- Product page ---------------------------------------------------- */

  function stockFor(variantId) {
    var maps = document.querySelectorAll('script[data-instyle-stock]');
    for (var i = 0; i < maps.length; i++) {
      try {
        var map = JSON.parse(maps[i].textContent);
        if (Object.prototype.hasOwnProperty.call(map, variantId)) {
          return { canBuy: map[variantId] === true, root: maps[i].closest('product-info') || document };
        }
      } catch (e) {}
    }
    return null;
  }

  function clearProductLimits(root) {
    (root || document).querySelectorAll('[data-stock-limit-line]').forEach(function (el) {
      el.remove();
    });
  }

  // The line goes straight under Add to cart / Buy it now, where the shopper
  // just pressed, and is removed again on the next variant change.
  function showProductLimit(root) {
    var note = root.querySelector('[data-stock-note]');
    var buttons = root.querySelector('.product-form__buttons');
    if (!note || !buttons) return;
    var html = note.dataset.limitText || (window.instyleCartLimit && window.instyleCartLimit.html) || '';
    if (!html) return;
    var err = root.querySelector('.product-form__error-message-wrapper');
    if (err) {
      err.setAttribute('hidden', '');
      var msg = err.querySelector('.product-form__error-message');
      if (msg) msg.textContent = '';
    }
    clearProductLimits(root);
    var line = document.createElement('p');
    line.className = 'instyle-stock__line instyle-stock__line--limit';
    line.setAttribute('role', 'status');
    line.setAttribute('data-stock-limit-line', '');
    // The sentence is a theme string and holds a tel: link.
    line.innerHTML = html;
    buttons.insertAdjacentElement('afterend', line);
  }

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.variantChange, function () {
      clearProductLimits(document);
    });
    subscribe(PUB_SUB_EVENTS.cartError, function (event) {
      if (!event || event.source !== 'product-form') return;
      var hit = stockFor(String(event.productVariantId));
      // Only a stock-tracked variant that could be bought a moment ago gets
      // the calm line; the red box product-form.js just filled is swapped for
      // it once that has finished (same sentence either way).
      if (!hit || !hit.canBuy) return;
      setTimeout(function () {
        showProductLimit(hit.root);
      }, 0);
    });
  }
})();
